module.exports = __webpack_public_path__ + "img/fb.38d97d4a.svg";